module.exports = __webpack_public_path__ + "img/cardIcon4@2x.5c6931f5.png";